import React from 'react';
import { Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import withAsyncLifecycle from '../../hoc/async-lifecycle';

const SELECT_OPTION_ID = '';

const Select = ({
    controlId, label, onChange, selectedValue, isInvalid, options, errorMessage, isFetching = false, isError = false,
}) => {
    const SelectContainerWithAsyncLifecycle = withAsyncLifecycle(SelectContainer, { isFetching, isError });
    const selectOptionName = useIntl().formatMessage({ id: 'please_select' });
    return (
        <Form.Group className="mb-3" controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Select onChange={onChange} isInvalid={isInvalid} value={selectedValue}>
                <option key={SELECT_OPTION_ID} value={SELECT_OPTION_ID} disabled={true}>{selectOptionName}</option>
                <SelectContainerWithAsyncLifecycle options={options} selectedValue={selectedValue} />
            </Form.Select>
            {errorMessage && <span className='text-danger'>{errorMessage}</span>}
        </Form.Group>
    );
};

const SelectContainer = ({ options }) => (
    <>
        {options.map((option) => (
            <option key={option.id} disabled={option.disabled || false} value={option.id}>{option.name}</option>
        ))}
    </>
);

export default Select;
